var map = {
	"./-43027.jpg": 299,
	"./-98797.jpg": 933,
	"./A dark and forboding magma chamber-12341.jpg": 680,
	"./A dark and forboding magma chamber-38228.jpg": 629,
	"./A dark and forboding magma chamber-52686.jpg": 113,
	"./A dark and forboding magma chamber-67184.jpg": 780,
	"./A dark and forboding magma chamber-87354.jpg": 943,
	"./A pink castle interior sparkly-67603.jpg": 408,
	"./Pink girl map-54866.jpg": 88,
	"./dark lair of a dragon-97757.jpg": 685,
	"./fa-97900.jpg": 597,
	"./goblin temple-98316.jpg": 194,
	"./kobold fortress-45242.jpg": 365,
	"./ornate-27857.jpg": 89,
	"./test0-15992.jpg": 87,
	"./test0-16586.jpg": 913,
	"./test0-33234.jpg": 832,
	"./test0-52562.jpg": 151,
	"./test0-59034.jpg": 162,
	"./test0-96374.jpg": 392,
	"./wizard tower-30847.jpg": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838;